// extracted by mini-css-extract-plugin
export default {"value":"Accordion_value__wwANv","price":"Accordion_price__oYV39","shape_wrap":"Accordion_shape_wrap__RfH9k","accordion":"Accordion_accordion__RrdOz"};